import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import { useOrderId } from './useOrderId'

export const useReviewerActions = () => {
  const orderId = useOrderId()
  const history = useHistory()


  const navigateToOrder = useCallback(() => {
    history.push(`/orders/${orderId}`)
  }, [history, orderId])

  const navigateToOrderWithSubmissionsTab = useCallback(() => {
    history.push(`/orders/${orderId}`, { activeTab: '4' })
  }, [history, orderId])

  const navigateBack = useCallback(() => {
    history.goBack()
  }, [history])

  const navigateToReviewer = useCallback(() => {
    history.push(`/orders/${orderId}/reviewer`)
  }, [history, orderId])

  const navigateToReviewerFromOrderId = useCallback((
    orderId,
    submissionVersion = undefined,
    newTab = false,
    section = undefined,
  ) => {
    if (!orderId) {
      console.warn('navigateToReviewerFromOrderId: orderId is required')
      return
    }

    let baseUrl = `/orders/${orderId}/reviewer`

    const searchParams = new URLSearchParams()
    if (submissionVersion) {
      searchParams.set('submission', submissionVersion)
    }
    if (section) {
      searchParams.set('section', section)
    }

    if (searchParams.toString()) {
      baseUrl = `${baseUrl}?${searchParams}`
    }

    if (newTab) {
      window.open(baseUrl, '_blank').focus()
    } else {
      history.push(baseUrl)
    }
  }, [history])

  const navigateToReviewerWithSection = useCallback((section) => {
    const currentParams = new URLSearchParams(window.location.search)

    if (section) {
      currentParams.set('section', section)
    } else {
      currentParams.delete('section')
    }

    const newUrl = currentParams.toString()
      ? `${window.location.pathname}?${currentParams}`
      : window.location.pathname

    history.push(newUrl)
  }, [history])

  return {
    navigateToOrder,
    navigateToOrderWithSubmissionsTab,
    navigateBack,
    navigateToReviewer,
    navigateToReviewerFromOrderId,
    navigateToReviewerWithSection,
  }
}
